import React, { Component } from 'react';
import Loader from '../../../Common/Component/Loader';
import { DatePicker, message, Select } from 'antd';
import moment from 'moment-timezone';
import Script from 'react-load-script';
import AllState from '../../../../Assets/data/stateList.json';
import { map, isEmpty } from 'lodash';
import * as yup from 'yup';
import cross_icon from "../../../../Assets/images/cross_icon.svg";
import {errorHandle} from "../../../Common/errorHandle";
import Axios from 'axios';
const { Option } = Select;

class AddFranchise extends Component {

  state = {
    userList: [],
    loader: false,
    temp_zipcode_1: '',
    temp_zipcode_2: '',
    temp_zipcode_3: '',
    new_franchise: {
      city: '',
      state: '',
      name: '',
      accountant_uuid: '',
      manager_uuid: '',
      owner_uuid: '',
      owned_zip_codes: [],
      addressable_zip_codes: [],
      new_cust_not_accept_zip_codes: [],
      aggrement_date: '',
      fein: ''
    },
    phone_number: { phone: '' },
    is_address_manually: false,
    franchise_address: { address: '', city: '', state: '', zip_code: '' },
    is_add_user_Active: false,
    errors: {}
  }

  componentDidMount = () => {
    // Get User  list
    this.props.getUserList({ 'offset': 0, 'limit': 15 });
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    // message.destroy();
    //Add new Franchise
    if (Object.keys(props.FranchiseAdd.data).length > 0 && props.FranchiseAdd.data !== this.props.FranchiseAdd.data) {
      this.setState({
        loader: false,
      })
      //get filed office list
      this.props.getFieldOffice({ limit: 15, offset: 0 });
      // get Franchise List
      this.props.getFranchiseList();
      this.props.closeAddDrawer(false);
    }

    if (Object.keys(props.FranchiseAdd.errors).length > 0 && props.FranchiseAdd.errors !== this.props.FranchiseAdd.errors) {
      message.error(props.FranchiseAdd.errors, 10);
      this.setState({
        loader: false,
      })
    }


    //Get User list
    if (Object.keys(props.UserList.data).length > 0 && props.UserList.data !== this.props.UserList.data) {
      this.setState({
        loader: false,
        UserList: props.UserList.data.results
      })
    }

    if (Object.keys(props.UserList.errors).length > 0 && props.UserList.errors !== this.props.UserList.errors) {
      errorHandle(props?.UserList?.errors)
      this.setState({
        loader: false,
      })
    }

    // get geocode
    if (Object.keys(props?.GoogleApi?.getGeocode) && JSON.stringify(props?.GoogleApi?.getGeocode) !== JSON.stringify(this.props?.GoogleApi?.getGeocode)) {
      this.setAddress(props?.GoogleApi?.getGeocode)
    }

  }

  //Render All State
  renderAllState = () => {
      return AllState.AllState.map((item, i) => {
        return (<Option value={item.abbreviation} key={i}>{item.name}</Option>)
    });
  }

  //render User list
  renderUser = () => {
    let { UserList } = this.state;
    return map(UserList, (item) => {
      return (
        <Option key={item.uuid}>{item.first_name} {item.last_name} </Option>
      )
    })
  }

  //Set New francbhise Text
  onFranchiseTextChange = (e) => {
    let { new_franchise } = this.state;
    new_franchise = Object.assign(new_franchise, { [e.target.name]: e.target.value });
    this.setState({
      new_franchise
    })
  }

  //Set Franchise Select value
  onSelectChange = (e, name) => {
    console.log(e)
    let { new_franchise } = this.state;
    new_franchise = Object.assign(new_franchise, { [name]: e });
    this.setState({
      new_franchise
    })
  }

  //Add Franchise Zipcode (Owned Zips)
  addNewOwnedZipCodes = () => {
    let { new_franchise, temp_zipcode_1, errors } = this.state;
    let zipcode = new_franchise['owned_zip_codes'];
    if (new_franchise['owned_zip_codes'].length > 0) {
      this.setState({errors: {}})
      if (new_franchise['owned_zip_codes'].includes(temp_zipcode_1)) {
        return
      }
    }

    if (temp_zipcode_1?.length === 5) {
      this.setState({errors: {}})
      zipcode.push(temp_zipcode_1)
    } else {
      this.setState({errors: {...errors, 'temp_zipcode_1': 'Invalid zipcode'}})
    }

    new_franchise = Object.assign(new_franchise, { 'owned_zip_codes': zipcode });
    this.setState({
      new_franchise,
      temp_zipcode_1: '',
    })

  }

  //Remove Own Zipcode
  removeOwnedZipCode = (e) => {
    let { new_franchise } = this.state;
    let { owned_zip_codes } = new_franchise;
    let index = owned_zip_codes.indexOf(e);
    owned_zip_codes.splice(index, 1);
    new_franchise = Object.assign(new_franchise, { owned_zip_codes });
    this.setState({
      new_franchise
    })
  }

  //Add Franchise Zipcode (Owned Zips)
  addNewAddressableZipCodes = () => {
    let { new_franchise, temp_zipcode_2, errors } = this.state;
    let zipcode = new_franchise['addressable_zip_codes'];
    if (new_franchise['addressable_zip_codes'].length === 5) {
      this.setState({errors: {}})
      if (new_franchise['addressable_zip_codes'].includes(temp_zipcode_2)) {
        return
      }
    }

    if (temp_zipcode_2?.length === 5) {
      this.setState({errors: {}})
      zipcode.push(temp_zipcode_2)
    } else {
      this.setState({errors: {...errors, 'temp_zipcode_2': 'Invalid zipcode'}})
    }
    new_franchise = Object.assign(new_franchise, { 'addressable_zip_codes': zipcode });
    this.setState({
      new_franchise,
      temp_zipcode_2: '',
    })

  }

  //Remove Addressable ZipCodes
  removeAddressableZipCode = (e) => {
    let { new_franchise } = this.state;

    let { addressable_zip_codes } = new_franchise;
    let index = addressable_zip_codes.indexOf(e);
    addressable_zip_codes.splice(index, 1);
    new_franchise = Object.assign(new_franchise, { addressable_zip_codes });
    this.setState({
      new_franchise
    })
  }

  //Add new customer not accept zip codes
  addNewCustNotAcceptZipCodes = () => {
    let { new_franchise, temp_zipcode_3, errors } = this.state;
    let zipcode = new_franchise['new_cust_not_accept_zip_codes'];
    if (new_franchise['new_cust_not_accept_zip_codes'].length === 5) {
      this.setState({errors: {}})
      if (new_franchise['new_cust_not_accept_zip_codes'].includes(temp_zipcode_3)) {
        return
      }
    }

    if (temp_zipcode_3?.length === 5) {
      this.setState({errors: {}})
      zipcode.push(temp_zipcode_3)
    } else {
      this.setState({errors: {...errors, 'temp_zipcode_3': 'Invalid zipcode'}})
    }
    new_franchise = Object.assign(new_franchise, { 'new_cust_not_accept_zip_codes': zipcode });
    this.setState({
      new_franchise,
      temp_zipcode_3: '',
    })

  }

  //Remove Addressable ZipCodes
  removeNotAcceptZipCode = (e) => {
    let { new_franchise } = this.state;

    let { new_cust_not_accept_zip_codes } = new_franchise;
    let index = new_cust_not_accept_zip_codes.indexOf(e);
    new_cust_not_accept_zip_codes.splice(index, 1);
    new_franchise = Object.assign(new_franchise, { new_cust_not_accept_zip_codes });
    this.setState({
      new_franchise
    })
  }

  // set address
  setAddress = (addressObject) => {
    if (!isEmpty(addressObject)) {
      if (addressObject?.status === "OK") {
        let obj = {}, components = addressObject?.results?.[0];
        map(components?.address_components, (item) => {
          if (item?.types?.includes('administrative_area_level_2')) {
            obj = Object.assign(obj, { 'address': item.short_name })
          }
          if (item?.types?.includes('route')) {
            obj = Object.assign(obj, { 'route': item.short_name })
          }
          if (item?.types?.includes('street_number')) {
            obj = Object.assign(obj, { 'street_number': item.short_name })
          }
          if (item?.types?.includes('administrative_area_level_1')) {
            obj = Object.assign(obj, { 'state': item.short_name })
          }
          if (item?.types?.includes('locality')) {
            obj = Object.assign(obj, { 'city': item.long_name })
          }
          if (item?.types?.includes('postal_code')) {
            obj = Object.assign(obj, { 'zip_code': item.short_name })
          }
        });
        this.setState({ franchise_address: obj });
      } else {
        message.error('Something went wrong while getting address')
      }
    }
  }

  // Google Map Place API
  handleScriptLoad = () => {
    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: 'us' } };

    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const newAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('franchise_address'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    newAutoComplete.setFields(['address_components', 'name', 'formatted_address']);

    // Fire Event when a suggested name is selected
    newAutoComplete.addListener('place_changed', this.handlePlaceSelect);

    this.setState({
      autocomplete: newAutoComplete,
    })

  };
  removeEmpty=(obj) =>{
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => (v !== null && v?.trim() !== "")));
  }
  handlePlaceSelect = () => {
    const address= document?.getElementById('franchise_address')?.value;
    Axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
      params: this.removeEmpty({
        latlng: undefined,
        address,
        key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
      })
    }).then((res) => {
      const addressObject = res?.data?.results[0];
      let obj = {};
      map(addressObject?.address_components, (item) => {
        if (item?.types?.includes('route') || item?.types?.includes('administrative_area_level_2')) {
          obj = Object.assign(obj, { 'address': item.short_name })
        }
        if (item?.types?.includes('route')) {
          obj = Object.assign(obj, { 'route': item.long_name })
        }
        if (item?.types?.includes('street_number')) {
          obj = Object.assign(obj, { 'street_number': item.short_name })
        }
        if (item?.types?.includes('administrative_area_level_1')) {
          obj = Object.assign(obj, { 'state': item.short_name })
        }
        if (item?.types?.includes('locality')) {
          obj = Object.assign(obj, { 'city': item.long_name })
        }
        if (item?.types?.includes('postal_code')) {
          obj = Object.assign(obj, { 'zip_code': item.short_name })
        }
      });
      this.setState({ franchise_address: obj });
    }).catch((err) => {
      console.log(err)
    })
    // const address_obj = (obj?.street_number || obj?.route) ? {...obj, address: `${obj?.street_number || ''} ${obj?.route || ''}`} : obj
    // const address = `${address_obj.address} ${address_obj.city} ${address_obj.state} ${address_obj.zip_code}`
    // this.props.resetGeocodeAddress()
    // this.props.getGeocodeAddress({key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY, address})
  }

  // on address change
  onAddressChange = (e) => {
    const {franchise_address} = this.state;
    Object.assign(franchise_address, {[e.target.name]: e.target.value})
    this.setState({franchise_address});
  };

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    console.log(((!isNaN(value) && reg.test(value)) || value === '' || value === '-'))
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  //Validate Data
  ValidateTicket = (e) => {
    e.preventDefault();
    let self = this;
    setTimeout(() => {
      let { new_franchise, franchise_address, phone_number } = this.state;
      const FranchiseSchema = yup.object().shape({
        new_franchise: yup.object().shape({
          city: yup.string().required("City is required"),
          state: yup.string().required("State is required"),
          // accountant_uuid: yup.string().required("Accountant is required"),
          // manager_uuid: yup.string().required("Manager is required"),
          // owner_uuid: yup.string().required("Owner is required"),
          aggrement_date: yup.string().required("aggrement date is required"),
          owned_zip_codes: yup.array().required("Zipcode is required"),
          addressable_zip_codes: yup.array().required("Zipcode is required"),
          // new_cust_not_accept_zip_codes: yup.array().required(),

        }),
        phone_number: yup.object().shape({
          phone: yup.string().required("Phone Number is required").min(10, 'Phone Number is required'),
        }),
        franchise_address: yup.object().shape({
          address: yup.string().required("Address is required"),
          city: yup.string().required("City is required"),
          state: yup.string().required("State is required"),
          zip_code: yup.string().required("Zipcode is required"),
        })
      })

      const FranchiseData = {
        new_franchise, franchise_address, phone_number
      }


      // check validity
      let IsValid;
      let err_data = {};
      FranchiseSchema.isValid(FranchiseData)
        .then(function (valid) {
          IsValid = valid
        });
      setTimeout(() => {
        if (IsValid) {
          self.setState({
            is_add_user_Active: true,
            errors: {}
          });
          //Call API For create franchsie 
          this.createNewFranchise()
        }
        else {
          FranchiseSchema.validate(FranchiseData, { abortEarly: false })
            .catch(function (err) {
              map(err.inner, (item) => {
                err_data[item.path] = item.message;

              })
              self.setState({
                errors: err_data,
                is_checkout_btn_active: false
              })
              console.log("err_data:", err_data)
              self.setState({
                is_add_user_Active: false
              })
            });
        }
      }, 100);
    }, 300);
  }

  //Call New Franchise API
  createNewFranchise = () => {
    let { new_franchise, franchise_address, phone_number } = this.state;

    new_franchise.name = new_franchise.city + new_franchise.state;

    const address = (franchise_address?.street_number && franchise_address?.route) ?
      `${franchise_address?.street_number || ''} ${franchise_address?.route || ''} ${franchise_address?.city || ''}, ${franchise_address?.state || ''} ${franchise_address?.zip_code || ''}` :
      `${franchise_address?.address || ''}, ${franchise_address?.city || ''}, ${franchise_address?.state || ''} ${franchise_address?.zip_code || ''}`

    const field_office_address = (franchise_address?.street_number && franchise_address?.route) ? {...franchise_address, address: `${franchise_address?.street_number} ${franchise_address?.route}`} : franchise_address
    if (!phone_number?.uuid) delete phone_number?.uuid

    let data = { ...new_franchise, address, phone_number, field_office_address }
    if (data?.new_cust_not_accept_zip_codes.length === 0) {
      data.new_cust_not_accept_zip_codes = []
    }
    if (!data?.accountant_uuid) {
      delete data.accountant_uuid;
    }
    if (!data?.manager_uuid) {
      delete data.manager_uuid;
    }
    if (!data?.owner_uuid) {
      delete data.owner_uuid;
    }
    // data.aggrement_date = data.aggrement_date?.toUTCString()
    // console.log("data:::>", JSON.stringify(data));
    this.setState({ loader: true, errors: {} })
    // Call API
    this.props.addFieldOffice(data)
    this.clearAll();
  }

  clearAll = () => {
    this.setState({
      new_franchise: {
        city: '',
        state: '',
        name: '',
        accountant_uuid: '',
        manager_uuid: '',
        owner_uuid: '',
        owned_zip_codes: [],
        addressable_zip_codes: [],
        new_cust_not_accept_zip_codes: [],
        aggrement_date: '',
        fein: ''
      },
      phone_number: { phone: '' },
      franchise_address: { address: '', city: '', state: '', zip_code: '' },
      is_address_manually: false,
      errors: {},
      temp_zipcode_1: '',
      temp_zipcode_2: '',
      temp_zipcode_3: '',
    })
    this.wrapperRef.value = '';
  }

  render() {
    let { new_franchise, phone_number, temp_zipcode_1, temp_zipcode_2, temp_zipcode_3, loader, errors, is_address_manually,
      franchise_address } = this.state;
    return (
      <div className="group_wrapper rdrawer">
        <div className="card-row">
          <div className="card-full">
            <h4>New Franchise Details</h4>
            <div className="form-group">
              <div className="fitem half-fitem">
                <div className="fitem half-fitem">
                  <label>City</label>
                  <input
                    type="text"
                    name="city"
                    autoComplete="franchise_city"
                    value={new_franchise.city}
                    onChange={(e) => { this.onFranchiseTextChange(e) }}
                    placeholder="City" />
                  {errors['new_franchise.city'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['new_franchise.city']}</label> : ''}
                </div>
                <div className="fitem half-fitem">
                  <label>State</label>
                  <Select
                    name="franchise_state"
                    onFocus={(event) => {
                      event.target.autocomplete = "franchise_state"
                    }}
                    showSearch
                    value={new_franchise.state || undefined}
                    onChange={(e) => { this.onSelectChange(e, 'state') }}
                    placeholder="State">
                    {this.renderAllState()}
                  </Select>
                  {errors['new_franchise.state'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['new_franchise.state']}</label> : ''}
                </div>
              </div>


              <div className="fitem">
                <label>Franchise Owner</label>
                <Select
                  showSearch
                  showArrow={true}
                  filterOption={false}
                  notFoundContent={null}
                  placeholder="Franchise Owner"
                  value={new_franchise.owner_uuid || undefined}
                  onChange={(e) => { this.onSelectChange(e, 'owner_uuid') }}
                  onSearch={(e) => { this.props.getUserList({ 'search': e }) }}
                  onBlur={() => { this.props.getUserList({ 'offset': 0, 'limit': 15 }); }}
                >
                  {this.renderUser()}
                </Select>
                {errors['new_franchise.owner_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['new_franchise.owner_uuid']}</label> : ''}
              </div>
              <div className="fitem">
                <label>Franchise Manager</label>
                <Select
                  showSearch
                  showArrow={true}
                  filterOption={false}
                  notFoundContent={null}
                  placeholder="Franchise Manager"
                  value={new_franchise.manager_uuid || undefined}
                  onChange={(e) => { this.onSelectChange(e, 'manager_uuid') }}
                  onSearch={(e) => { this.props.getUserList({ 'search': e }) }}
                  onBlur={() => { this.props.getUserList({ 'offset': 0, 'limit': 15 }); }}

                >
                  {this.renderUser()}
                </Select>
                {errors['new_franchise.manager_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['new_franchise.manager_uuid']}</label> : ''}
              </div>
              <div className="fitem">
                <label>Franchise Accountant</label>
                <Select
                  showSearch
                  showArrow={true}
                  filterOption={false}
                  notFoundContent={null}
                  placeholder="Franchise Accountant"
                  value={new_franchise.accountant_uuid || undefined}
                  onChange={(e) => { this.onSelectChange(e, 'accountant_uuid') }}
                  onSearch={(e) => { this.props.getUserList({ 'search': e }) }}
                  onBlur={() => { this.props.getUserList({ 'offset': 0, 'limit': 15 }); }}
                >
                  {this.renderUser()}
                </Select>
                {errors['new_franchise.accountant_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['new_franchise.accountant_uuid']}</label> : ''}
              </div>



              <div className="fitem relative">
                <label>Franchise Zipcode (Owned Zips)</label>
                <div className="fitem-rinner">
                  <input
                    placeholder="Franchise Zipcode, Comma Delimited"
                    type="text"
                    inputMode="numeric"
                    max='5'
                    maxLength='5'
                    name='temp_zipcode_1'
                    value={temp_zipcode_1}
                    onChange={(e) => { this.setState({ 'temp_zipcode_1': e.target.value }) }}
                    onPaste={(event) => {
                      if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                        event.preventDefault();
                      }
                    }}
                    onKeyPress={(e) => {
                      const pattern = /[0-9]/;
                      const inputChar = String.fromCharCode(e.charCode);
                      if (!pattern.test(inputChar)) {
                        // invalid character, prevent input
                        e.preventDefault();
                      }
                    }}
                  />
                  <div className="fitem-ricon">
                    {temp_zipcode_1 ?
                      <i
                        onClick={() => { this.addNewOwnedZipCodes() }}
                        className="las la-plus-circle add_zipcode_icon"
                      ></i> : ''}
                  </div>
                  {errors['new_franchise.owned_zip_codes'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['new_franchise.owned_zip_codes']}</label> : ''}
                  {errors['temp_zipcode_1'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['temp_zipcode_1']}</label> : ''}
                </div>
                               
                {new_franchise.owned_zip_codes.length > 0 ? <div className="zip_code_list">
                  <b>Sort: Lowest to Highest</b>
                  <ul>
                    {
                      map(new_franchise.owned_zip_codes, (item) => {
                        return (<li key={item}>{item} <i onClick={() => { this.removeOwnedZipCode(item) }} className="las la-times-circle"></i> </li>)
                      })
                    }
                  </ul>
                </div> : ''}

              </div>
              <div className="fitem relative">
                <label>Franchise Zipcode (Serviced Zips)</label>
                <div className="fitem-rinner">
                  <input
                    placeholder="Franchise Zipcode, Comma Delimited"
                    type="text"
                    inputMode="numeric"
                    max='5'
                    maxLength='5'
                    name='addressable_zip_codes'
                    value={temp_zipcode_2}
                    onChange={(e) => { this.setState({ 'temp_zipcode_2': e.target.value }) }}
                    onPaste={(event) => {
                      if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                        event.preventDefault();
                      }
                    }}
                    onKeyPress={(e) => {
                      const pattern = /[0-9]/;
                      const inputChar = String.fromCharCode(e.charCode);
                      if (!pattern.test(inputChar)) {
                        // invalid character, prevent input
                        e.preventDefault();
                      }
                    }}
                  />
                  <div className="fitem-ricon">
                    {temp_zipcode_2 ?
                      <i
                        onClick={() => { this.addNewAddressableZipCodes('addressable_zip_codes') }}
                        className="las la-plus-circle add_zipcode_icon"
                      ></i> : ''}
                  </div>
                  {errors['new_franchise.addressable_zip_codes'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['new_franchise.addressable_zip_codes']}</label> : ''}
                  {errors['temp_zipcode_2'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['temp_zipcode_2']}</label> : ''}
                </div>
                {new_franchise.addressable_zip_codes.length > 0 ?
                  <div className="zip_code_list">
                    <b>Sort: Lowest to Highest</b>
                    <ul>
                      {
                        map(new_franchise.addressable_zip_codes, (item) => {
                          return (<li key={item}>{item} <i onClick={() => { this.removeAddressableZipCode(item) }} className="las la-times-circle"></i> </li>)
                        })

                      }
                    </ul>
                  </div>
                  : ''}
              </div>
              <div className="fitem relative">
                <label>Franchise Zipcode (Serviced, New Customers Not Accepted)</label>
                <div className="fitem-rinner">
                  <input
                    placeholder="Franchise Zipcode, Comma Delimited"
                    type="text"
                    inputMode="numeric"
                    max='5'
                    maxLength='5'
                    name='temp_zipcode_3'
                    value={temp_zipcode_3}
                    onChange={(e) => { this.setState({ 'temp_zipcode_3': e.target.value }) }}
                    onPaste={(event) => {
                      if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                        event.preventDefault();
                      }
                    }}
                    onKeyPress={(e) => {
                      const pattern = /[0-9]/;
                      const inputChar = String.fromCharCode(e.charCode);
                      if (!pattern.test(inputChar)) {
                        // invalid character, prevent input
                        e.preventDefault();
                      }
                    }}
                  />
                  <div className="fitem-ricon">
                    {temp_zipcode_3 ?
                      <i
                        onClick={() => { this.addNewCustNotAcceptZipCodes() }}
                        className="las la-plus-circle add_zipcode_icon"
                      ></i>: ''}
                  </div>
                  {errors['temp_zipcode_3'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['temp_zipcode_3']}</label> : ''}
                </div>

                {new_franchise.new_cust_not_accept_zip_codes.length > 0 ?
                  <div className="zip_code_list">
                    <b>Sort: Lowest to Highest</b>
                    <ul>
                      {
                        map(new_franchise.new_cust_not_accept_zip_codes, (item) => {
                          return (<li key={item}>{item} <i onClick={() => { this.removeNotAcceptZipCode(item) }} className="las la-times-circle"></i> </li>)
                        })
                      }
                    </ul>
                  </div>
                  : ''}
              </div>

              <div>
                <div className="google_search_place mb-10">
                  <Script
                    url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
                    onLoad={() => window.requestAnimationFrame(this.handleScriptLoad)}
                  />
                  <label>Franchise Address</label>
                  <input
                    autoComplete="off"
                    type="text"
                    ref={(input) => { this.wrapperRef = input; }}
                    className={is_address_manually ? 'google_search_disable form--control' : 'form--control'}
                    placeholder="Franchise Address"
                    name="franchise_address"
                    id="franchise_address"
                    onChange={(e) => {
                      if (!e.target.value) {
                        this.setState({
                          franchise_address: { address: '', state: '', city: '', zipcode: '' },
                        })
                      }
                    }}
                    disabled={is_address_manually}
                  />
                  <b>or <a href="/" onClick={(e) => {
                    e.preventDefault();
                    this.setState({
                      is_address_manually: true,
                      franchise_address: { address: '', state: '', city: '', zipcode: '' },
                    }, () => {
                      if (this.wrapperRef) {
                        this.wrapperRef.value = '';
                      } })
                  }}><u>enter address manually</u></a></b>

                </div>
                {
                  is_address_manually &&
                  <div className="manually_address">
                    <a className="float-right" href="/#" onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        is_address_manually: false,
                        franchise_address: { address: '', state: '', city: '', zipcode: '' },
                      })
                    }}><img src={cross_icon} alt="" className="remove_address" /></a>
                    <br />

                    <div className="form-group">
                      <div className="fitem">
                        <input
                          type="text"
                          placeholder="Address"
                          name="address"
                          value={franchise_address?.address}
                          onChange={(e) => this.onAddressChange(e)}
                        />
                      </div>
                      <div className="fitem">
                        <input
                          type="text"
                          className='form--control'
                          placeholder="City"
                          name="city"
                          value={franchise_address?.city}
                          onChange={(e) => this.onAddressChange(e)}
                        />
                      </div>
                      <div className="fitem">
                        <Select
                          showArrow={true}
                          name="state"
                          placeholder="State"
                          onChange={(value) => this.onAddressChange({ target: { name: 'state', value: value } })}
                          value={franchise_address?.state || undefined}
                          virtual={false}
                        >
                          {this.renderAllState()}
                        </Select>
                      </div>

                      <div className="fitem">
                        <input
                          type="text"
                          className='form--control'
                          placeholder="ZIP Code"
                          name="zip_code"
                          maxLength={5}
                          minLength={5}
                          onChange={(e) => this.onNumericInputChange(e.target.value) && this.onAddressChange(e)}
                          value={franchise_address?.zip_code || ''}
                        />
                      </div>
                    </div>
                  </div>
                }
              </div>

              <div className="fitem">
                <label>Franchise Number</label>
                <div className={phone_number.phone ? 'fix_isd_code' : ''}>
                  {phone_number.phone ? <span>+1</span> : ''}
                  <input
                    style={{marginLeft: "10px"}}
                    placeholder="Franchise Number"
                    name="phone_number"
                    value={phone_number.phone}
                    onChange={(e) => {
                      phone_number = Object.assign(phone_number, { 'phone': e.target.value });
                      this.setState({
                        phone_number
                      })
                    }}
                    type="text"
                    inputMode="numeric"
                    max='10'
                    maxLength='10'
                    onPaste={(event) => {
                      if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                        event.preventDefault();
                      }
                    }}
                    onKeyPress={(e) => {
                      const pattern = /[0-9]/;
                      const inputChar = String.fromCharCode(e.charCode);
                      if (!pattern.test(inputChar)) {
                        // invalid character, prevent input
                        e.preventDefault();
                      }
                    }}
                  />
                  {errors['phone_number.phone'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['phone_number.phone']}</label> : ''}
                </div>

              </div>
              <div className="fitem">
                <label>Date Agreement Signed</label>
                <DatePicker
                  style={{ 'width': '100%' }}
                  name='aggrement_date'
                  format="MM/DD/YYYY"
                  suffixIcon={<i className="las la-calendar"></i>}
                  disabledDate={(endValue) => { return endValue.valueOf() >= moment().valueOf(); }}
                  allowClear={false}
                  onChange={(e) => {
                    new_franchise = Object.assign(new_franchise, { 'aggrement_date': moment(e).format('YYYY-MM-DD') });
                    this.setState({
                      new_franchise
                    })
                  }}
                  value={new_franchise.aggrement_date ? moment(new_franchise.aggrement_date) : null}
                />
                {errors['new_franchise.aggrement_date'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['new_franchise.aggrement_date']}</label> : ''}
              </div>
              <div className="fitem">
                <label>FEIN</label>
                <input
                  type="text"
                  className='form--control'
                  placeholder="FEIN"
                  name="fein"
                  onChange={(e) => this.onFranchiseTextChange(e)}
                  value={new_franchise?.fein || ''}
                />
              </div>
            </div>
            <div className="footer" style={{ 'width': '420px' }}>
              <button
                onClick={() => {
                  this.setState({
                    new_franchise: {
                      city: '',
                      state: '',
                      name: '',
                      accountant_uuid: '',
                      manager_uuid: '',
                      owner_uuid: '',
                      owned_zip_codes: [],
                      addressable_zip_codes: [],
                      new_cust_not_accept_zip_codes: [],
                      aggrement_date: '',
                      fein: ''
                    },
                    phone_number: { phone: '' },
                    franchise_address: { address: '', city: '', state: '', zip_code: '' },
                    is_address_manually: false,
                    errors: {},
                    temp_zipcode_1: '',
                    temp_zipcode_2: '',
                    temp_zipcode_3: '',
                  })
                  this.wrapperRef.value = ''


                  this.props.closeAddDrawer(false)
                }}
                className="btn btn-brand btn-bdr"
              >Cancel</button>
              <button
                // className={!is_add_user_Active ? 'btn disabled' : 'btn btn-warning'}
                className='btn btn-warning'
                // disabled={!is_add_user_Active}

                onClick={(e) => {
                  this.ValidateTicket(e)

                }}
              >Start Setup</button>
            </div>
          </div>
        </div>
        {loader ? < Loader /> : ''}
      </div>
    );
  }
}

export default AddFranchise;